import * as React from "react";
import { useState } from "react";
import { Collapse, List, ListItemText, Box, ListItemButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { iconSize } from "./tools";
import { FormattedMessage } from "react-intl";

type Props = {
    items: string[];
    icon: React.ReactNode;
    label: React.ReactNode;
    itemPrefix: string;
};

const AutoNestedListItem = ({ items, icon, label, itemPrefix }: Props) => {
    const [open, setOpen] = useState(false);

    if (items.length === 0) return null;

    if (items.length === 1)
        return (
            <ListItemButton component="a" href={itemPrefix + items[0]}>
                {icon}
                <ListItemText primary={label} secondary={items[0]} sx={{ wordBreak: "break-all" }} />
            </ListItemButton>
        );

    return (
        <React.Fragment>
            <ListItemButton onClick={() => setOpen(!open)}>
                {icon}
                <ListItemText
                    primary={label}
                    secondary={
                        <FormattedMessage id="meetingPage.clientSelector.showAll" defaultMessage="Show all..." />
                    }
                />
                <Box sx={{ paddingRight: "1.3em" }}>
                    {open ? (
                        <FontAwesomeIcon icon="angle-up" size="lg" />
                    ) : (
                        <FontAwesomeIcon icon="angle-down" size="lg" />
                    )}
                </Box>
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List dense component="div" disablePadding>
                    {items.map((item) => (
                        <ListItemButton
                            key={item}
                            component="a"
                            href={itemPrefix + item}
                            sx={{ paddingLeft: `${iconSize * 1.5}px` }}
                        >
                            <ListItemText primary={item} sx={{ wordBreak: "break-all" }} />
                        </ListItemButton>
                    ))}
                </List>
            </Collapse>
        </React.Fragment>
    );
};

export default AutoNestedListItem;
